import type { Activity } from '@/modules/documents/domain/entities/activity';
import {
  ActivityFileAction,
  ActivityType,
} from '@/modules/documents/domain/entities/activity-type';

import { FeApi } from '../../fetch-client';

type ApiCategoryData = 'Create' | 'Delete' | 'Update';

const mapping: Record<ApiCategoryData, ActivityFileAction> = {
  Create: ActivityFileAction.CREATE,
  Delete: ActivityFileAction.DELETE,
  Update: ActivityFileAction.UPDATE,
};

export function activityMapper(data: FeApi.ActivityRead): Activity {
  return {
    id: data.uuid,
    createdAt: new Date(data.timestamp),
    siteIds: data.sites_accure_ids,
    type: ActivityType.USER_FILE,
    action: mapping[data.category],
    user: {
      displayName: data.user_name,
    },
    document: {
      id: data.document_uuid,
      name: data.document_name,
      isAvailable: data.document_visible,
    },
    details: data.details,
  };
}
